export default __webpack_public_path__ + "static/media/hello-stickerwalter.c53339cd.svg";